import { render, staticRenderFns } from "./gj-setting-custom-modal.vue?vue&type=template&id=1008f9ec&scoped=true&"
import script from "./gj-setting-custom-modal.vue?vue&type=script&lang=js&"
export * from "./gj-setting-custom-modal.vue?vue&type=script&lang=js&"
import style0 from "./gj-setting-custom-modal.vue?vue&type=style&index=0&id=1008f9ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008f9ec",
  null
  
)

export default component.exports